import React from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from './Header';
import MainContent from './MainContent';
import { useCompany } from '../../contexts/CompanyContext';

interface EzraLayoutProps {
  children?: React.ReactNode;
}

const EzraLayout: React.FC<EzraLayoutProps> = ({ children }) => {
  const { currentCompany } = useCompany();

  return (
    <div className="h-screen flex overflow-hidden" style={{ backgroundColor: 'var(--color-surface-content)' }}>
      {/* Sidebar */}
      <Sidebar />

      {/* Main content area */}
      <div className="flex flex-col flex-1 overflow-hidden">
        <Header />
        <MainContent>
          {children || <Outlet key={currentCompany?.id} />}
        </MainContent>
      </div>
    </div>
  );
};

export default EzraLayout;
